import { RoleName, User } from "@/api/users-types";
import { useUser } from "@/queries/auth";

export function hasRole(user: User, roleOrRoles: RoleName | RoleName[]): boolean {
  const roleNames = Array.isArray(roleOrRoles) ? roleOrRoles : [roleOrRoles];
  return user.roles.some((role) => roleNames.includes(role.name));
}

export function useHasRole(roleOrRoles: RoleName | RoleName[], { enabled }: { enabled?: boolean } = {}) {
  const { data: user } = useUser({ enabled });
  return !!user && hasRole(user, roleOrRoles);
}
